import { Capacitor } from "@capacitor/core";

export type NativePlatform = "ios" | "android" | "web";

/**
 * True when running inside the Capacitor native shell (the iOS/Android app),
 * false in a normal browser and during SSR. Cheap and synchronous — the
 * platform never changes at runtime, so no subscription is needed.
 */
export function isNativeApp(): boolean {
  if (typeof window === "undefined") return false;
  return Capacitor.isNativePlatform();
}

/** Current runtime platform. Returns "web" in a browser and during SSR. */
export function getNativePlatform(): NativePlatform {
  if (typeof window === "undefined") return "web";
  const platform = Capacitor.getPlatform();
  return platform === "ios" || platform === "android" ? platform : "web";
}
